import axios from 'axios/index'

const namespaced = true

const state = {
  companyId: null,
  companyProfile: null,
  opfValue: [],
  FCSData: null,
  CTMData: null,
  FNSData: null,
  fnsContentUrl: '',
  companiesData: []
}
const actions = {
  addCompanyData ({ commit, state, rootState }, data) {
    return axios({
      method: 'PUT',
      url: '/api/private/v3.0/companies/' + rootState.activateUser.user.company.id + '/',
      data: data
    })
      .then(response => {
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  },
  editCompanyData ({ state, rootState }, data) {
    return axios({
      method: 'PATCH',
      url: '/api/private/v3.0/companies/' + rootState.userInfo.company.id + '/',
      data: data
    })
  },
  loadOpfValue ({ state, commit }) {
    return axios({
      method: 'GET',
      url: '/api/private/v3.0/list/company/opfs/'
    })
      .then(response => {
        commit('setOpfValue', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getCompanyData ({ commit, rootState }, data) {
    return axios({
      method: 'GET',
      url: '/api/private/v3.0/companies/' + rootState.userInfo.company.id + '/'
    })
      .then(response => {
        commit('getCompanyProfile', response.data)
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  },
  setPassByMobile ({ commit, state, rootState }) {
    return axios({
      method: 'POST',
      url: '/api/private/v3.0/companies/' + rootState.activateUser.user.company.id + '/users/' + rootState.activateUser.user.id + '/set-password/'
    })
      .then(response => {
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getCompaniesData ({ commit }) {
    return axios({
      method: 'GET',
      url: '/api/private/v3.0/companies/'
    })
      .then(response => {
        console.log(response)
        commit('setCompanies', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getCompanyDataProfile ({ commit, state, dispatch, rootState }) {
    // await dispatch('getCompanyData')
    return axios({
      method: 'GET',
      url: '/api/private/v3.0/companies/' + rootState.userInfo.company.id + '/'
    })
      .then(response => {
        console.log(response)
        commit('getCompanyProfile', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getCTMId ({ commit, state }) {
    return axios({
      method: 'POST',
      url: '/api/private/v3.0/ctm/organizations/search/',
      data: {
        inn: state.companyProfile.inn,
        kpp: state.companyProfile.kpp,
        dealer_id: 77
      }
    })
      .then(response => {
        console.log(response)
        commit('getCTMData', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getFCSProfile ({ commit, state }) {
    return axios({
      method: 'POST',
      url: '/api/private/v3.0/infodec/organizations/logins/',
      data: {
        inn: state.companyProfile.inn,
        kpp: state.companyProfile.kpp
      }
    })
      .then(response => {
        console.log(response)
        commit('getFCSData', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  checkFNS ({ commit, state }) {
    return axios({
      method: 'GET',
      url: '/api/private/v3.0/nalog/egrul/' + state.companyProfile.inn + '/'
    })
      .then(response => {
        console.log(response)
        commit('getFNSData', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getFillBillId ({ commit, state }) {
    return axios({
      method: 'POST',
      url: '/api/private/v3.0/companies/' + state.companyId + '/group/'
    })
      .then(response => {
        // swal('Вы получили Fill-Bill ID', '', 'success')
        console.log(response)
      })
      .catch(error => {
        // swal('Ошибка', error.response.data.detail, 'error')
        console.log(error)
      })
  }

}
const mutations = {
  getCompanyID (state, data) {
    state.companyId = data
    console.log(data)
  },
  getCompanyProfile (state, data) {
    state.companyProfile = data
    console.log(data)
  },
  setOpfValue (state, data) {
    data.forEach(function (elm) {
      elm.label = elm.short_name
    })
    state.opfValue = data
    console.log(data)
  },
  getFCSData (state, data) {
    state.FCSData = data
    console.log(data)
  },
  getCTMData (state, data) {
    state.CTMData = data
    console.log(data)
  },
  setCompanies (state, data) {
    state.companiesData = data
  },
  getFNSData (state, data) {
    state.FNSData = data
    state.fnsContentUrl = '/api/private/v3.0/nalog/egrul/' + state.companyProfile.inn + '/document/' + data.document.id + '/content/'
    console.log(data)
  }
}
const getters = {}

export default {
  namespaced,
  state,
  actions,
  mutations,
  getters
}
